// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"AddressAutoComplete_searchBox__mMOmt","suggestions":"AddressAutoComplete_suggestions__2MPwd","suggestionItem":"AddressAutoComplete_suggestionItem__HzV-4"};